/* eslint-disable indent */
import { EditProposal } from 'features/Proposal';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function EditProposalPage() {
    return (
        <LayoutProvider>
            <Layout>
                <EditProposal />
            </Layout>
        </LayoutProvider>
    );
}

export default EditProposalPage;
